<template>
    <div class="mt-4">
        <timeslots
            :log="log"
            :registration="registration"
            :simulation="simulation"
            :session="session"
            :stats="stats"
            :competencies="competencies"
            :grid-competencies="gridCompetencies"
            :types="types"
            :lang="lang"
            :redirect="redirect"
            :filters="filters"
            @filtersChanged="$emit('filtersChanged', $event)"
            @refresh="$emit('refresh')">
        </timeslots>
        <back-to-top></back-to-top>
    </div>
</template>

<script>
    import Timeslots from './Timeslots'

    export default {

        components: {
            Timeslots
        },

        props: {

            log: {
                type: Object,
                required: true
            },

            registration: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },

            session: {
                type: Object,
                default: null
            },

            types: {
                type: Object,
                required: true
            },
            
            competencies: {
                type: Object,
                default: null
            },
            
            gridCompetencies: {
                type: Object,
                default: null
            },
            
            stats: {
                type: Object,
                default: null
            },

            lang: {
                type: String,
                default: "en"
            },
            
            redirect: {
                type: Object,
                default: null
            },

            filters: {
                type: Object,
                default: {}
            },
        }
    }
</script>
